import React, { useCallback, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@components/form';

export default function NavigationSearch({ inputRef, active, onSearchClick }) {
  const btnSubmit = useRef(null);
  const [searchText, setSearchText] = useState('');

  const handleKeydown = useCallback(({ key }) => {
    if (key === 'Enter') {
      btnSubmit.current.click();
    }
  }, []);

  if (!active) {
    return null;
  }

  const searchQueryPrefix = searchText ? `?filter.searchText=${searchText}&` : '?';

  return (
    <div className='navigation__search__container'>
      <div className='component'>
        <input
          ref={inputRef}
          type='text'
          placeholder='Search for documents...'
          onChange={(event) => setSearchText(event.target.value)}
          onKeyDown={handleKeydown}
        />
        <Button
          ref={btnSubmit}
          to={`/search${searchQueryPrefix}sort=updatedAt,desc`}
          color='red'
          onClick={onSearchClick}
        >
          <i className='icon--search' />
        </Button>
      </div>
    </div>
  );
}

NavigationSearch.propTypes = {
  active: PropTypes.bool.isRequired,
  inputRef: PropTypes.object.isRequired,
  onSearchClick: PropTypes.func.isRequired,
};
